import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import {connect} from "react-redux";
import {compose} from "recompose";
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import {filterStyles} from '../shared/styles-filter';

/**
 * Text Input field
 * http://redux-form.com/6.4.3/examples/material-ui/
 *
 * @param touched
 * @param error
 * @param inputProps
 * @param props
 * @return {*}
 */
const renderInput = ({meta: {touched, error} = {}, input: {...inputProps}, ...props}) =>
    <TextField
        errorText={touched && error}
        {...inputProps}
        {...props}
        fullWidth
    />;

/**
 * A form containing a SelectInput component with Mode choices
 *
 */
class InventoryTransferIdFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transferIdValue: null
        };
        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    /**
     * Handle selection event for Transfer ID
     *
     * @param event
     * @param index
     * @param value
     */
    handleFieldChange(event, index, value) {
        this.setState({
            transferIdValue: index
        });
    }

    /**
     * Handle submission event for Transfer ID
     */
    handleSubmit() {
        let id = this.state.transferIdValue;
        if (id) {
            this.props.onSubmitTransferId(id);
        }
    }

    render() {
        const id = this.state.transferIdValue;
        const disableButton = (!id || id === '' || id.length < 1);

        const styles = {
            button: {display: 'inline-block', margin: '0.5em 0 0 0'},
            field: {display: 'block', maxWidth: '80%'}
        };

        return (
            <form>
                <div className="list-filter">
                    <Field
                        name="transfer_id"
                        type="text"
                        component={renderInput}
                        floatingLabelText="Transfer ID"
                        onChange={this.handleFieldChange}
                        style={styles.field}
                    />
                    <RaisedButton
                        primary
                        label="Submit"
                        onClick={this.handleSubmit}
                        disabled={disableButton}
                        style={styles.button}
                    />
                    <hr style={filterStyles.break}/>
                </div>
            </form>
        );
    }
}

InventoryTransferIdFilter.propTypes = {
    addField: PropTypes.bool,
    onSubmitTransferId: PropTypes.func,
};

InventoryTransferIdFilter.defaultProps = {
    addField: true,
};

const enhance = compose(
    connect(),
    reduxForm({
        form: 'filterForm',
        enableReinitialize: true,
    })
);

export default enhance(InventoryTransferIdFilter);



// WEBPACK FOOTER //
// ./src/Fuse/components/InventoryTransferIdFilter.js